class checkStreamsListCtrl {
    constructor($scope, $location, logger, httpRequest) {
        // 初始化表单数据
        $scope.resData = []
        httpRequest.get_qryApproveConfigList().then((res) => {
            if (res.data.success) {
                $scope.resData = res.data.value
            }
        })

        // 按钮滑过
        $scope.dropdown_rowhover = function (row, flag) {
            row.dropdownhover = flag
        }

        // 禁用
        $scope.toEnabled = function (item, index) {
            httpRequest.get_setApproveValidStatus({
                approveCode: item.approveCode,
                isValid: '0',
            }).then((res) => {
                $scope.resData[index].isValid = '0'
                logger.logSuccess('禁用成功！')
            })
        }

        // 启用
        $scope.toAbled = function (item, index) {
            httpRequest.get_setApproveValidStatus({
                approveCode: item.approveCode,
                isValid: '1',
            }).then((res) => {
                $scope.resData[index].isValid = '1'
                logger.logSuccess('启用成功！')
            })
        }

        // 设置
        $scope.toSettingPage = function (item, index) {
            $location.path(`/system/settingcenter/checkStreams/setting/${item.approveCode}`).replace()
        }
    }
}

checkStreamsListCtrl.$inject = ['$scope', '$location', 'logger', 'httpRequest']
export default checkStreamsListCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/checkStreams/checkStreamsListCtrl.js